import { Box, BoxProps, styled } from '@mui/material';

const StyledStepperWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  borderRight: `0.1rem solid ${theme.palette.border.light}`,
  height: 'calc(100vh - 8rem)',
  padding: theme.spacing(3),
}));

export default StyledStepperWrapper;
